import React from 'react';
import ProductCard from "./ProductCard";

const Products = () => {
    const productData = [
        {
            icon: "square_foot",
            title: "Tiles & Granite",
            description: "Premium quality ceramic, porcelain, and natural stone tiles for floors and walls"
        },
        {
            icon: "plumbing",
            title: "CP Fittings",
            description: "Durable and stylish CP fittings for modern plumbing solutions"
        },
        {
            icon: "bathtub",
            title: "Bath Fittings",
            description: "Elegant and functional bath fittings to enhance your bathroom experience"
        },
        {
            icon: "wash",
            title: "Sanitary Ware",
            description: "Modern and hygienic sanitary ware solutions for homes and businesses"
        }
    ];

    return (
        <section className="products">
            <div className="container">
                <div className="section-title">
                    <h2>Our Product Range</h2>
                    <p>Discover our extensive collection of premium building materials and bathroom solutions</p>
                </div>
                <div className="product-grid">
                    {productData.map((product, index) => (
                        <ProductCard
                            key={index}
                            icon={product.icon}
                            title={product.title}
                            description={product.description}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Products;
